import { useDropdownOptions, useDropdownValue } from 'hooks';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';

export const ADJUSTMENT_METHODS = {
    BID_CONTROL: 'BID_CONTROL',
    BID_MODIFIER: 'BID_MODIFIER',
};

export const adjustmentMethodOptions = [
    {
        value: ADJUSTMENT_METHODS.BID_CONTROL,
        label: (
            <FormattedMessage
                id="campaign.editor.bid.adjustment.method.option.BID_CONTROL"
                defaultMessage="Set type and amount"
            />
        ),
    },
    {
        value: ADJUSTMENT_METHODS.BID_MODIFIER,
        label: (
            <FormattedMessage
                id="campaign.editor.bid.adjustment.method.option.BID_MODIFIER"
                defaultMessage="Increase / Reduce (CPC/CPM) amount"
            />
        ),
    },
];

export const useAdjustmentMethodOptions = ({ adjustmentMethod }) => {
    const adjustmentMethodDropdownOptions = useDropdownOptions(
        adjustmentMethodOptions,
        'campaign.editor.bid.adjustment.method.option'
    );
    const selectedValue = useDropdownValue({ value: adjustmentMethod }, 'campaign.editor.bid.adjustment.method.option');

    return {
        dropdownOptions: adjustmentMethodDropdownOptions,
        selectedValue: adjustmentMethod ? selectedValue : null,
    };
};
